<template>
  <div id="Introduction_page">
    <div class="card mb-3" id="About_Project">
      <div class="card-header" style="text-align: left; font-size: 22px">
          <B> Spam & Reject Policy </B>
      </div>
      <div class="card-body">
        <div class="card-text" style="color: black; line-height: 160%; text-align: left">
          As we occasionally find people, who have passed all our qualification task, but submitting weird annotations to us
          (e.g., submitting a question like "Ho do yu get this grrr??", "What should I do to revive the dead?") or
          submitting data doesn't meet the specified criteria we provided.
          If we later find that your performance is significantly lower than what you did in the qualification task,
          we reserve the right of not dispensing bonus or even reject your HITs.
          For non-spammers, don't worry; we're not harsh on this, all we want to do is to avoid spammers. Thanks for your understanding.
        </div>
      </div>
    </div>
    <br/>

    <div class="card" id="Whole_Architecture">
      <div class="card-header" style="text-align: left; font-size: 22px">
        <B> Payment & Bonus </B>
      </div>
      <div class="card-body">
        <div class="card-text" style="color: black; margin-left: 20px; text-align: left;">
          <ol>
            <li>
              At first, you are given ten questions to modify and generate. We will reward you $0.7 for every each data you created.
              If you complete and submit all the data, you will receive a total of $7 reward.
            </li>
            <br>
            <li>
              If the contents of the provided data are strange or do not make sense to you or do not meet the criteria, you can either amend or pass the question.
              However, please note that you cannot get reward for skipped questions.
            </li>
            <br>
            <li>
              But don't worry, you can still continue to generate as many data as you want even you have skipped any questions.
              We will reward you $0.7 for every each data you create.
              You are able to receive a total of 40 additional data, 5 data each for 8 times, and earn up to $35 together with the basic reward in the first.
              Of course, you should be paying attention on the quality of the data.
            </li>
            <br/>
            <li>
              Because dataset creation is carried out in parallel with validation task, after all work is completed, the reward will be paid in the form of a bonus within 3 weeks along with a qualification pass reward ($1).
            </li>
          </ol>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Payment.vue"
}
</script>

<style scoped>

</style>